// Angular Files
import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from "@angular/common";

// Angular Material Files

// Other External Files

// Component Files
import { TellerOnlinePaymentMethodComponent } from "./payment-method.component";

//Teller Online Library Files
import { TellerOnlineIconsModule } from "teller-online-libraries/icons";
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { TellerOnlineSharedModule } from 'libraries/shared/src/lib/module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [TellerOnlinePaymentMethodComponent],
    imports: [
        RouterModule,
        MatLegacyCardModule,
        MatIconModule,
        MatLegacyButtonModule,
        TellerOnlineIconsModule,
        TellerOnlineSharedModule
    ],
    exports: [TellerOnlinePaymentMethodComponent]
})
export class TellerOnlinePaymentMethodModule {}
